import { createFileRoute } from '@tanstack/react-router'
import { Share2 } from 'lucide-react'
import { z } from 'zod'
import { KnowledgeScreen } from '@/screens/investigate/SCR-015-knowledge'

export const Route = createFileRoute('/_app/w/$ws/knowledge')({
  staticData: { screen: { id: 'SCR-015', title: 'Knowledge graph', group: 'Investigate', perm: 'graph.read', order: 6, description: 'Entities and relations ESM has learned, with their sources.', icon: Share2 } },
  validateSearch: z.object({ limit: z.coerce.number().int().min(10).max(300).optional().catch(undefined) }),
  component: KnowledgeScreen,
})
